export const markdownHeaderClasses = {
    h1: "heading-2xl",
    h2: "heading-xl",
    h3: "heading-lg",
    h4: "text-base font-semibold",
    h5: "text-sm font-semibold",
    h6: "text-sm font-regular italic",
};
export const markdownParagraphSize = "text-base leading-relaxed";
//# sourceMappingURL=markdownSizes.js.map